import { render } from "./removePosition.vue?vue&type=template&id=16d9ef8e&ts=true"
import script from "./removePosition.vue?vue&type=script&lang=ts"
export * from "./removePosition.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__